<template>
  <footer
    :id="blok.sectionLinkId"
    class="jb-footer-3-cols"
    :class="backgroundColorClass(blok.bgVariant)"
    aria-labelledby="footerHeading"
  >
    <h2 id="footerHeading" class="sr-only">Voettekst</h2>
    <div class="mx-auto max-w-7xl px-4 pt-12 sm:px-6 lg:px-8 lg:pt-16">
      <div class="">
        <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3">
          <div class="md:col-span-2 md:grid md:grid-cols-2 md:gap-8">
            <slot name="col-1" />
            <div class="mt-12 md:mt-0">
              <slot name="col-2" />
            </div>
          </div>
          <div class="md:col-span-1 md:gap-8">
            <slot name="col-3" />
          </div>
        </div>
      </div>
    </div>
    <FooterBottomBar v-bind="$props" />
  </footer>
</template>

<script setup>
import FooterBottomBar from '../components/FooterBottomBar.vue'
import { useColorPalette } from '../composables/colorPalette'

defineProps({
  blok: {
    type: Object,
    default: () => {},
  },
  context: {
    type: Object,
    default: () => {},
  },
})

const { backgroundColorClass } = useColorPalette()
</script>

<style scoped>
@reference "../css/theme.css";

:deep(.rich-text-light) a {
  @apply text-gray-300 hover:text-white focus:text-white;
}

:deep(.rich-text-dark) a {
  @apply text-gray-700 hover:text-gray-800 focus:text-gray-800;
}
</style>
